<app-text-input [label]="'city' | translate" maxLengthKey="city" [control]="control()" [required]="required()"></app-text-input>
